export var TeaClassNames = {
    Margin: {
        "1n": "tea-ma-1n",
        "2n": "tea-ma-2n",
        "3n": "tea-ma-3n",
        "4n": "tea-ma-4n",
        "5n": "tea-ma-5n",
        Top: {
            "1n": "tea-mt-1n",
            "2n": "tea-mt-2n",
            "3n": "tea-mt-3n",
            "4n": "tea-mt-4n",
            "5n": "tea-mt-5n",
        },
        Bottom: {
            "1n": "tea-mb-1n",
            "2n": "tea-mb-2n",
            "3n": "tea-mb-3n",
            "4n": "tea-mb-4n",
            "5n": "tea-mb-5n",
        },
        Left: {
            "1n": "tea-ml-1n",
            "2n": "tea-ml-2n",
            "3n": "tea-ml-3n",
            "4n": "tea-ml-4n",
            "5n": "tea-ml-5n",
        },
        Right: {
            "1n": "tea-mr-1n",
            "2n": "tea-mr-2n",
            "3n": "tea-mr-3n",
            "4n": "tea-mr-4n",
            "5n": "tea-mr-5n",
        },
    },
    Padding: {
        "1n": "tea-pa-1n",
        "2n": "tea-pa-2n",
        "3n": "tea-pa-3n",
        "4n": "tea-pa-4n",
        "5n": "tea-pa-5n",
        Top: {
            "1n": "tea-pt-1n",
            "2n": "tea-pt-2n",
            "3n": "tea-pt-3n",
            "4n": "tea-pt-4n",
            "5n": "tea-pt-5n",
        },
        Bottom: {
            "1n": "tea-pb-1n",
            "2n": "tea-pb-2n",
            "3n": "tea-pb-3n",
            "4n": "tea-pb-4n",
            "5n": "tea-pb-5n",
        },
        Left: {
            "1n": "tea-pl-1n",
            "2n": "tea-pl-2n",
            "3n": "tea-pl-3n",
            "4n": "tea-pl-4n",
            "5n": "tea-pl-5n",
        },
        Right: {
            "1n": "tea-pr-1n",
            "2n": "tea-pr-2n",
            "3n": "tea-pr-3n",
            "4n": "tea-pr-4n",
            "5n": "tea-pr-5n",
        },
    },
    FontSizeReset: "tea-fz-reset",
};
//# sourceMappingURL=index.js.map